import { mutations } from './mutations';
import { queries } from './queries';

const mocks = [...queries, ...mutations];

export default mocks;
